<template>
  <v-card>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="6" class="pl-8">
        <v-col cols="12" sm="12" md="12" lg="6">
          <v-text-field
            v-model="phoneNumber"
            hide-details="auto"
            outlined
            dense
            type="number"
            label="Phone Number"
            required
          ></v-text-field>
        </v-col>
        <v-col>
          <v-form>
            <v-textarea
              v-model="message"
              label="Message"
              counter
              maxlength="100"
              outlined
              dense
              hide-details="auto"
            >
            </v-textarea>
          </v-form>
        </v-col>
        <v-col cols="12" class="text-right pa-0">
          <v-btn
            depressed
            small
            class="ml-1 text-white btn_medium"
            color="primary"
            @click="sendSingleMessage"
          >
            <v-icon left small> mdi-send </v-icon>Send</v-btn
          >
        </v-col>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="6">
        <SmsTemplates @change="monthChanged" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import SmsTemplates from './SMSTempatesComponent.vue';
export default {
  data: () => ({
    phoneNumber: '',
    message: '',
  }),

  components: {
    SmsTemplates,
  },
  methods: {
    monthChanged(data) {
      this.message = data;
    },
    sendSingleMessage() {
      let singleSMSData = {
        phoneNumber: this.phoneNumber,
        message: this.message,
      };
      this.isLoading = true;

      this.$store
        .dispatch('sms/SendSingleandBulkSMS', singleSMSData)
        .then((res) => {
          if (res.data.message == 'Your SMS Notification is Disabled') {
            this.$toast.error(res.data.message);
          } else {
            this.$toast.success(res.data.message);
          }

          this.isLoading = false;
          this.phoneNumber = '';
          this.message = '';
          window.location.reload();
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('SMS Send failed');
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
  },
};
</script>
